import React from "react";
import { apiCallPost, niceDateTime } from "../fns/util";
import {
  Button,
  Input,
  Space,
  Table,
  Tag,
  Spin,
  Alert,
  Drawer,
  Popconfirm,
  message,
} from "antd";
import { FileTextOutlined } from "@ant-design/icons";
import _ from "lodash";
import PaperSubmissionForm from "./Paper";
import ThesisSubmissionForm from "./Thesis";
import PosterSubmissionForm from "./Poster";
import VideoSubmissionForm from "./Video";
import ICSubmissionForm from "./InstructionCourse";

class SubmissionList extends React.Component {
  state = {
    dataSource: [],
    columns: [],
    searchString: "",
    isLoading: true,
    isError: false,
    selectedRecord: null,
    showDrawer: false,
    results: [],
  };
  componentDidMount() {
    this.getSubmissions();
  }
  getSubmissions = async () => {
    let token = await this.props.context.provideToken();
    let apiUrl = "/conference2023/getSubmissions";
    if (this.props.isVideoJudge) {
      apiUrl = "/conference2023/getSubmissionsForVideoJudge";
    }
    if (this.props.isOPCJudge) {
      apiUrl = "/conference2023/getSubmissionsForOPCJudge";
    }
    if (this.props.isAdmin) {
      apiUrl = "/conference2023/getAllSubmissions";
    }
    try {
      const res = await apiCallPost(token, apiUrl, {});
      this.setState(
        { results: res.submissions, isLoading: false, isError: false },
        () => {
          this.transformToTableForm();
        }
      );
    } catch (err) {
      console.log(err);
      this.setState({ isLoading: false, isError: true });
    }
  };
  transformToTableForm = () => {
    let results = this.state.results;
    let data = results;
    if (this.state.searchString) {
      data = results.filter((item) => {
        return item.title
          .toLowerCase()
          .includes(this.state.searchString.toLowerCase());
      });
    }
    let dataSource = data;
    let columns = [
      {
        title: "#",
        key: "serialNumber",
        dataIndex: "serialNumber",
      },
      {
        title: "Type",
        key: "submissionType",
        dataIndex: "submissionType",
        render: (x, record) => {
          return (
            <Tag>
              {record.submissionType === "IC"
                ? "IC"
                : _.startCase(_.lowerCase(record.submissionType))}
            </Tag>
          );
        },
        filters: [
          {
            text: "Paper",
            value: "PAPER",
          },
          {
            text: "Poster",
            value: "POSTER",
          },
          {
            text: "Video",
            value: "VIDEO",
          },
          {
            text: "Instruction Course",
            value: "IC",
          },
          {
            text: "OPC",
            value: "OPC",
          },
          {
            text: "PGT Thesis",
            value: "THESIS",
          },
        ],
        onFilter: (value, record) => {
          return record.submissionType === value;
        },
      },
      { title: "Title", key: "title", dataIndex: "title" },
      {
        title: "Primary Author",
        key: "presentingAuthorName",
        dataIndex: "presentingAuthorName",
      },
      {
        title: "Authors",
        key: "authors",
        dataIndex: "authors",
        render: (x, record) => {
          return (
            <p className="smaller_text">
              {_.join(
                _.map(
                  record.authors,
                  (a) => `${a.name} [${a.email} | ${a.mobile}]`
                ),
                ", "
              )}
            </p>
          );
        },
      },
      {
        title: "Award Track",
        key: "awardTrack",
        dataIndex: "awardTrack",
        filters: [
          {
            text: "Paper",
            value: "PAPER",
            children: [
              {
                text: "Dr B K Mitra Competition for Papers",
                value: "Dr B K Mitra Competition for Papers",
              },
              {
                text: "Dr K P Roy Competition for Papers",
                value: "Dr K P Roy Competition for Papers",
              },
              {
                text: "Smt Satya Rani Hazra Competition for Papers in Community Ophthalmology",
                value:
                  "Smt Satya Rani Hazra Competition for Papers in Community Ophthalmology",
              },
            ],
          },
          {
            text: "Poster",
            value: "POSTER",
            children: [
              {
                text: "Dr Anadi Bhushan Basu Competition for Posters",
                value: "Dr Anadi Bhushan Basu Competition for Posters",
              },
            ],
          },
          {
            text: "Video",
            value: "VIDEO",
            children: [
              {
                text: "Smt Sovabati Das Ghosh Competition for Videos",
                value: "Smt Sovabati Das Ghosh Competition for Videos",
              },
            ],
          },
          {
            text: "Other",
            value: "OTHER",
            children: [
              {
                text: "<None Selected>",
                value: "",
              },
            ],
          },
        ],
        onFilter: (value, record) => {
          if (value == null) {
            return true;
          } else {
            return record.awardTrack === value;
          }
        },
      },
      {
        title: "Status",
        key: "lifecycle",
        dataIndex: "lifecycle",
        render: (x, record) => {
          let colorMap = {
            DRAFT: "orange",
            SUBMITTED: "blue",
            WITHDRAWN: "red",
            ACCEPTED: "green",
            REJECTED: "red",
          };
          if (record.submissionType === "VIDEO") {
            if (record.videoList && record.videoList.length > 0) {
              return (
                <Tag color={colorMap[record.lifecycle]}>
                  {_.startCase(_.lowerCase("Video Uploaded"))}
                </Tag>
              );
            }
          }
          return (
            <Tag color={colorMap[record.lifecycle]}>
              {_.startCase(_.lowerCase(record.lifecycle))}
            </Tag>
          );
        },
        filters: [
          {
            text: "Draft",
            value: "DRAFT",
          },
          {
            text: "Submitted",
            value: "SUBMITTED",
          },
          {
            text: "Accepted",
            value: "ACCEPTED",
          },
          {
            text: "Rejected",
            value: "REJECTED",
          },
          {
            text: "Withdrawn",
            value: "WITHDRAWN",
          },
        ],
        onFilter: (value, record) => {
          return record.lifecycle === value;
        },
      },
      {
        title: "Metadata",
        key: "createdAt",
        render: (x, record) => {
          return (
            <p className="smaller_text">
              Created by <b>{record.createdByName}</b> on{" "}
              {niceDateTime(record.createdAt)}. Last updated:{" "}
              {niceDateTime(record.updatedAt)}
            </p>
          );
        },
      },
      /*   {
        title: "Action",
        key: "action",
        render: (x, record) => {
          return <>{this.renderActionBar(record)}</>;
        },
      }, */
    ];
    this.setState({
      dataSource,
      columns,
    });
  };
  createNew = async (submissionType) => {
    let token = await this.props.context.provideToken();
    try {
      message.loading("Creating new submission...");
      const res = await apiCallPost(
        token,
        "/conference2023/createEmptySubmission",
        {
          submissionType,
        }
      );
      message.success("New submission created.");
      this.props.onNew(res.submission);
    } catch (err) {
      console.log(err);
      message.error("Error creating new submission.");
    }
  };
  renderDetailsDrawer = () => {
    if (!this.state.selectedRecord) {
      return null;
    }
    let type = this.state.selectedRecord.submissionType;
    let maps = {
      THESIS: (
        <ThesisSubmissionForm
          loggedInUser={this.props.preloadedData}
          preloadedData={this.state.selectedRecord}
          isAdmin={this.props.isAdmin}
          context={this.props.context}
        />
      ),
      PAPER: (
        <PaperSubmissionForm
          loggedInUser={this.props.preloadedData}
          preloadedData={this.state.selectedRecord}
          isAdmin={this.props.isAdmin}
          context={this.props.context}
        />
      ),
      POSTER: (
        <PosterSubmissionForm
          loggedInUser={this.props.preloadedData}
          preloadedData={this.state.selectedRecord}
          isAdmin={this.props.isAdmin}
          context={this.props.context}
        />
      ),
      VIDEO: (
        <VideoSubmissionForm
          loggedInUser={this.props.preloadedData}
          preloadedData={this.state.selectedRecord}
          isAdmin={this.props.isAdmin}
          isVideoJudge={this.props.isVideoJudge}
          isOPCJudge={this.props.isOPCJudge}
          context={this.props.context}
        />
      ),
      OPC: (
        <VideoSubmissionForm
          loggedInUser={this.props.preloadedData}
          preloadedData={this.state.selectedRecord}
          isAdmin={this.props.isAdmin}
          isVideoJudge={this.props.isVideoJudge}
          isOPCJudge={this.props.isOPCJudge}
          context={this.props.context}
        />
      ),
      IC: (
        <ICSubmissionForm
          loggedInUser={this.props.preloadedData}
          preloadedData={this.state.selectedRecord}
          isAdmin={this.props.isAdmin}
          context={this.props.context}
        />
      ),
    };
    return (
      <Drawer
        title={`Submission Details: ${this.state.selectedRecord.title}`}
        placement="right"
        closable={true}
        open={this.state.showDrawer}
        size="large"
        onClose={() => {
          this.setState({
            showDrawer: false,
            selectedRecord: null,
          });
        }}
      >
        {this.renderActionBar()}
        {maps[type]}
      </Drawer>
    );
  };
  deleteSubmission = async (submission) => {
    let token = await this.props.context.provideToken();
    try {
      message.loading("Deleting submission...");
      await apiCallPost(token, "/conference2023admin/deleteSubmission", {
        submissionId: submission._id,
      });
      let dataSource = this.state.dataSource;
      let idx = _.findIndex(dataSource, (x) => x._id === submission._id);
      dataSource.splice(idx, 1);
      this.setState({
        showDrawer: false,
        selectedRecord: null,
        dataSource: dataSource,
      });
      message.success("Submission deleted.");
    } catch (err) {
      console.log(err);
      message.error("Error deleting submission.");
    }
  };
  reviewSubmission = async (submission, judgement) => {
    let token = await this.props.context.provideToken();
    try {
      message.loading("Reviewing submission...");
      let res = await apiCallPost(
        token,
        "/conference2023admin/reviewSubmission",
        {
          submissionId: submission._id,
          judgement,
        }
      );
      let results = this.state.results;
      let idx = _.findIndex(results, (x) => x._id === submission._id);
      results[idx] = res.submission;

      this.setState(
        {
          showDrawer: false,
          selectedRecord: null,
          results: results,
        },
        () => {
          this.transformToTableForm();
        }
      );
      message.success("Submission reviewed.");
    } catch (err) {
      message.error("Error reviewing submission.");
      console.log(err);
    }
  };

  renderActionBar = (record = null) => {
    if (!this.props.isAdmin) {
      return null;
    }
    if (!record && !this.state.selectedRecord) {
      return null;
    }
    let submission = record || this.state.selectedRecord;
    if (["ACCEPTED", "REJECTED"].includes(submission.lifecycle)) {
      if (submission.lifecycle === "ACCEPTED") {
        if (submission.scheduledSessionId) {
          return (
            <>
              <Popconfirm
                title="Delete this submission"
                description="Are you sure to delete this submission?"
                onConfirm={() => {
                  this.deleteSubmission(submission);
                }}
                onCancel={() => {}}
                okText="Yes"
                cancelText="No"
              >
                <Button danger>Delete Submission</Button>
              </Popconfirm>{" "}
              <Tag color="green">
                Accepted & Scheduled in Session:{" "}
                {submission.scheduledSessionTitle}
              </Tag>
            </>
          );
        } else {
          return (
            <>
              {" "}
              <Popconfirm
                title="Delete this submission"
                description="Are you sure to delete this submission?"
                onConfirm={() => {
                  this.deleteSubmission(submission);
                }}
                onCancel={() => {}}
                okText="Yes"
                cancelText="No"
              >
                <Button danger>Delete Submission</Button>
              </Popconfirm>
              <Tag color="blue">Accepted but Not Scheduled Yet</Tag>
            </>
          );
        }
      } else {
        return (
          <>
            <Popconfirm
              title="Delete this submission"
              description="Are you sure to delete this submission?"
              onConfirm={() => {
                this.deleteSubmission(submission);
              }}
              onCancel={() => {}}
              okText="Yes"
              cancelText="No"
            >
              <Button danger>Delete Submission</Button>
            </Popconfirm>
            <Tag color="red">Rejected</Tag>
          </>
        );
      }
    }
    return (
      <Space direction={record ? "vertical" : ""}>
        <Popconfirm
          title="Accept this submission"
          description="Are you sure to accept this submission?"
          onConfirm={() => {
            this.reviewSubmission(submission, "ACCEPTED");
          }}
          onCancel={() => {}}
          okText="Yes"
          cancelText="No"
        >
          <Button type="primary">Accept Submission</Button>
        </Popconfirm>
        <Popconfirm
          title="Reject this submission"
          description="Are you sure to reject this submission?"
          onConfirm={() => {
            this.reviewSubmission(submission, "REJECTED");
          }}
          onCancel={() => {}}
          okText="Yes"
          cancelText="No"
        >
          <Button type="primary" danger>
            Reject Submission
          </Button>
        </Popconfirm>{" "}
        <Popconfirm
          title="Delete this submission"
          description="Are you sure to delete this submission?"
          onConfirm={() => {
            this.deleteSubmission(submission);
          }}
          onCancel={() => {}}
          okText="Yes"
          cancelText="No"
        >
          <Button danger>Delete Submission</Button>
        </Popconfirm>
      </Space>
    );
  };
  render() {
    // Check if data is still loading
    if (this.state.isLoading) {
      return (
        <div>
          <Spin />
        </div>
      );
    }
    // Check if there was an error loading the data
    if (this.state.isError) {
      return (
        <Alert
          message="Error"
          description="An error occurred while loading the data."
          type="error"
          showIcon
        />
      );
    }
    /*   let keyString = this.state.dataSource
      .map((x) => `${x._id}__${x.updatedAt}`)
      .join("__"); */
    return (
      <div>
        {this.renderDetailsDrawer()}
        <Space.Compact
          style={{
            marginBottom: 16,
          }}
        >
          <Button type="text" disabled>
            Search
          </Button>
          <Input
            value={this.state.searchString}
            onChange={(e) =>
              this.setState(
                {
                  searchString: e.target.value,
                },
                () => {
                  this.transformToTableForm();
                }
              )
            }
          ></Input>
          {/* <Button icon={<FileTextOutlined />} disabled={true}>
            Submission have been closed.
          </Button> */}
          <Button onClick={() => this.createNew("THESIS")}>
            New PGT Thesis Submission
          </Button>
          {this.props.isAdmin ? (
            <>
              <Button onClick={() => this.createNew("PAPER")}>New Paper</Button>
              <Button onClick={() => this.createNew("POSTER")}>
                New Poster
              </Button>{" "}
              <Button onClick={() => this.createNew("VIDEO")}>New Video</Button>{" "}
              <Button onClick={() => this.createNew("IC")}>New IC</Button>
            </>
          ) : null}
        </Space.Compact>
        <Table
          //   key={keyString}
          onRow={(record) => {
            return {
              onClick: () => {
                this.setState({
                  showDrawer: true,
                  selectedRecord: record,
                });
              },
            };
          }}
          dataSource={[...this.state.dataSource]}
          columns={this.state.columns}
          rowKey={(record) => {
            return `submission__${record._id}__${record.updatedAt}__`;
          }}
          size="small"
          pagination={{
            defaultPageSize: 100,
          }}
        />
      </div>
    );
  }
}

export default SubmissionList;
